import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  AbstractControl,
} from "@angular/forms";
import { CommonService } from "../../../../services/common.service";
import { CartService } from "../../../../services/cart.service";
import { ReservationService } from "../../../../services/reservation.service";
import { AuthService } from "../../../../services/auth.service";
import { AppConfig } from "../../../../configs/app";

@Component({
  selector: "page-reserve-passenger-plan-2",
  templateUrl: "./plan-2.component.html",
})
export class PageReservePassengerPlan2Component implements OnInit {
  public postData: any = {};

  /* SET representationType TAB */
  public representationType: number = 1;

  public listUser: any = [];
  public postForm: FormGroup;
  public cartData: any;
  public userList: any;
  public formModel: any;
  public insurancePassengerData1: any;

  public _: any;
  public $: any;
  public moment: any;

  /* CUSTOM VALIDATOR */
  public myValidator: any = {};

  /* FOR TEMPORARY ASSIGNING */
  public tempData: any = {};

  constructor(
    public formBuilder: FormBuilder,
    public commonService: CommonService,
    public cartService: CartService,
    public reservationService: ReservationService,
    public authService: AuthService,
    public appConfig: AppConfig
  ) {
    let self = this;
    this._ = this.commonService.getLodash();
    this.$ = this.commonService.getJQuery();
    this.moment = this.commonService.getMoment();

    /* CUSTOM VALIDATOR */
    this.myValidator.isKana = function (control: AbstractControl): any {
      if (!self.commonService.isKana(control.value)) {
        return { isKana: true };
      }
      return null;
    };

    this.myValidator.isNumeric = function (control: AbstractControl): any {
      if (
        control.value &&
        control.value != "" &&
        !self.commonService.isNumeric(control.value)
      ) {
        return { isNumeric: true };
      }
      return null;
    };

    this.myValidator.menOrWomenOnly = function (control: AbstractControl): any {
      if (self.cartData) {
        if (
          self.cartData[1].plan.womenOnly &&
          control.value == appConfig.reservation.defaultUserData.sexMale
        ) {
          return { womenOnly: true };
        } else if (
          self.cartData[1].plan.menOnly &&
          control.value == appConfig.reservation.defaultUserData.sexFemale
        ) {
          return { menOnly: true };
        }
      }
      return null;
    };

    this.myValidator.minAge = function (control: AbstractControl): any {
      let age = control.value;
      if (control.value && control.value != "") {
      } else {
        age = 0;
      }

      let minAgeData = self.reservationService.getMinAgeByOfficeCode(
        self.cartData[1].plan.office_code
      );

      /* CHECK HAS AT LEAST 1 minAgeData */
      if (minAgeData != self.appConfig.reservation.passengerAgeLimit.min) {
        /* RESET ALL AGE INPUTS */
        let keyPrefix = "2_p_age_";
        if (self.postForm) {
          for (let i = 0; i < self.listUser.length; i++) {
            if (
              self.postForm.controls[`${keyPrefix}${i + 1}`].value >= minAgeData
            ) {
              minAgeData = self.appConfig.reservation.passengerAgeLimit.min;
              break;
            }
          }

          /* RESET AGE VALIDATORS */
          for (let i = 0; i < self.listUser.length; i++) {
            self.postForm.controls[`${keyPrefix}${i + 1}`].setValidators([
              Validators.required,
              self.myValidator.isNumeric,
              self.myValidator.minAge,
              Validators.max(self.tempData.maxAge),
            ]);
            if (
              self.postForm.controls[`${keyPrefix}${i + 1}`].errors &&
              self.postForm.controls[`${keyPrefix}${i + 1}`].errors.minAgeData
            ) {
              self.postForm.controls[`${keyPrefix}${i + 1}`].errors.minAgeData =
                minAgeData;
              if (
                self.postForm.controls[`${keyPrefix}${i + 1}`].value >=
                minAgeData
              ) {
                self.postForm.controls[`${keyPrefix}${i + 1}`].setErrors(null);
              }
            }
            self.postForm.controls[`${keyPrefix}${i + 1}`].markAsUntouched();
          }
        }
      }
      /* END */

      if (parseInt(age) < minAgeData) {
        return { minAge: true, minAgeData: minAgeData };
      }
      return null;
    };
  }

  async ngOnInit() {
    this.commonService.showPageLoader("読み込み中...");

    this.cartData = this.cartService.getCartData();
    this.userList = await this.reservationService.getPassengerData();

    /* CHECK IF HAS DATA */
    if (this._.isEmpty(this.cartData) || this._.isEmpty(this.userList[1])) {
      return this.commonService.redirectToRoute(
        this.commonService.routePaths.pagePlanList
      );
    }

    this.insurancePassengerData1 =
      this.reservationService.getInsurancePassengerData1();

    this.listUser = this.userList[1].list;

    /* INIT FORM DATA */
    this.postData = this.reservationService.getReservationData();
    /* GET LAST representationType */
    if (this.postData["representationType_plan2"]) {
      this.representationType = this.postData["representationType_plan2"];
      if (this.representationType == 2) {
        this.tempData.representationType2Chosen = true;
      }

      this.initFormData();
    } else {
      this.representationType = this.postData["representationType_plan1"];
      if (this.representationType == 2) {
        this.tempData.representationType2Chosen = true;
      }
      this.initFormDataFromPlan1();
    }

    /* ON FORM VALUE CHANGES */
    this.postForm.valueChanges.subscribe((data) => {
      this.tempData.errorMember = null;
    });
    /* END */

    this.tempData.formSubmitted = false;

    // INLINE JS
    this.inlineJS();

    this.commonService.hidePageLoader();
  }

  initFormData() {
    let formParams = {};

    for (let key in this.postData) {
      formParams[key] = "";
      let temp = [
        "2_p_mei",
        "2_p_sei",
        "2_p_age",
        "2_p_sex",
        "2_p_tel_1",
        "2_p_birth_date",
      ].filter((item) => key.indexOf(item) !== -1);
      if (temp.length !== 0) {
        if (key.indexOf("2_p_sex") !== -1) {
          let sex = this.postData[key]
            ? parseInt(this.postData[key])
            : this.appConfig.reservation.defaultUserData.sexMale;
          formParams[key] = [
            sex,
            [Validators.required, this.myValidator.menOrWomenOnly],
          ];
        } else if (key.indexOf("2_p_age") !== -1) {
          this.tempData.maxAge =
            this.cartData[1].passenger.adult.total == 0
              ? this.appConfig.reservation.passengerAgeLimit.childrenMax
              : this.appConfig.reservation.passengerAgeLimit.max;
          formParams[key] = [
            this.postData[key],
            [
              Validators.required,
              this.myValidator.isNumeric,
              this.myValidator.minAge,
              Validators.max(this.tempData.maxAge),
            ],
          ];
        } else if (key.indexOf("2_p_tel_1") !== -1) {
          if (key == "2_p_tel_1") {
            formParams[key] = [
              this.postData[key],
              [
                Validators.required,
                Validators.minLength(10),
                Validators.maxLength(11),
              ],
            ];
          } else {
            formParams[key] = this.postData[key];
          }
        } else if (key.indexOf("2_p_birth_date") !== -1) {
          formParams[key] = [this.postData[key]];
        } else {
          formParams[key] = [
            this.postData[key],
            [Validators.required, this.myValidator.isKana],
          ];
        }
      } else {
        formParams[key] = this.postData[key];
      }
    }
    this.postForm = this.formBuilder.group(formParams);
  }

  initFormDataFromPlan1() {
    let formParams = {};

    for (let key in this.postData) {
      let plan1Key = key.replace("2_", "1_");

      formParams[key] = "";
      let temp = [
        "2_p_mei",
        "2_p_sei",
        "2_p_age",
        "2_p_sex",
        "2_p_tel_1",
        "2_p_birth_date",
      ].filter((item) => key.indexOf(item) !== -1);
      if (temp.length !== 0) {
        if (key.indexOf("2_p_sex") !== -1) {
          let sex = this.postData[plan1Key]
            ? parseInt(this.postData[plan1Key])
            : this.appConfig.reservation.defaultUserData.sexMale;
          formParams[key] = [
            sex,
            [Validators.required, this.myValidator.menOrWomenOnly],
          ];
        } else if (key.indexOf("2_p_age") !== -1) {
          this.tempData.maxAge =
            this.cartData[1].passenger.adult.total == 0
              ? this.appConfig.reservation.passengerAgeLimit.childrenMax
              : this.appConfig.reservation.passengerAgeLimit.max;
          formParams[key] = [
            this.postData[plan1Key],
            [
              Validators.required,
              this.myValidator.isNumeric,
              this.myValidator.minAge,
              Validators.max(this.tempData.maxAge),
            ],
          ];
        } else if (key.indexOf("2_p_tel_1") !== -1) {
          if (key == "2_p_tel_1") {
            formParams[key] = [
              this.postData[plan1Key],
              [
                Validators.required,
                Validators.minLength(10),
                Validators.maxLength(11),
              ],
            ];
          } else {
            formParams[key] = this.postData[key];
          }
        } else if (key.indexOf("2_p_birth_date") !== -1) {
          formParams[key] = [this.postData[plan1Key]];
        } else {
          formParams[key] = [
            this.postData[plan1Key],
            [Validators.required, this.myValidator.isKana],
          ];
        }
      } else {
        formParams[key] = this.postData[key];
      }
    }
    this.postForm = this.formBuilder.group(formParams);
  }

  /* TAB 1: 1; TAB 2: 2 */
  setRepresentationData() {
    if (this.tempData.representationType2Chosen) {
      if (this.postData["representationType_plan2"]) {
        /* this.refillPassengerData(); */
      } else {
        /* this.initFormDataFromPlan1(); */
      }

      if (this.representationType == 1) {
        this.refillPrimaryPassengerData();
      }
    } else {
      if (this.postData["representationType_plan2"]) {
        /* this.refillPassengerData(); */
      } else {
        /* this.initFormDataFromPlan1(); */
      }

      if (this.representationType == 1) {
        this.refillPrimaryPassengerData();
      } else {
        this.emptyPrimaryPassengerData();
      }
    }
  }

  /* SET PASSENGER DATA */
  refillPassengerData() {
    for (let key in this.postForm.value) {
      let temp = [
        "2_p_mei",
        "2_p_sei",
        "2_p_age",
        "2_p_sex",
        "2_p_tel_1",
        "2_p_birth_date",
      ].filter((item) => key.indexOf(item) !== -1);
      if (temp.length !== 0) {
        if (key.indexOf("2_p_sex") !== -1) {
          let sex = this.postData[key]
            ? parseInt(this.postData[key])
            : this.appConfig.reservation.defaultUserData.sexMale;
          this.postForm.controls[key].setValue(sex);
        } else {
          this.postForm.controls[key].setValue(this.postData[key]);
        }
      }
    }
  }

  refillPrimaryPassengerData() {
    let reservationData = this.reservationService.getReservationData();
    this.postForm.controls["2_p_mei_1"].setValue(reservationData.c_mei);
    this.postForm.controls["2_p_sei_1"].setValue(reservationData.c_sei);
    this.postForm.controls["2_p_tel_1"].setValue(reservationData.c_tel);
    this.postForm.controls["2_p_age_1"].setValue(
      this.moment().diff(reservationData.c_birthday, "years")
    );

    let sex = reservationData.c_sex
      ? parseInt(reservationData.c_sex)
      : this.appConfig.reservation.defaultUserData.sexMale;
    this.postForm.controls["2_p_sex_1"].setValue(sex);
  }

  emptyPrimaryPassengerData() {
    this.postForm.controls["2_p_mei_1"].setValue("");
    this.postForm.controls["2_p_sei_1"].setValue("");
    this.postForm.controls["2_p_age_1"].setValue("");
    this.postForm.controls["2_p_tel_1"].setValue("");
    this.postForm.controls["2_p_sex_1"].setValue(
      this.appConfig.reservation.defaultUserData.sexMale
    );
  }
  /* END */

  validateMembers() {
    this.tempData.errorMember = {};

    let stats = {
      adultMen: 0,
      adultWomen: 0,
      childrenMen: 0,
      childrenWomen: 0,
    };

    /* CALCULATE DATA */
    for (let i = 1; i <= this.userList[1].list.length; i++) {
      if (
        this.postForm.value[`2_p_sex_${i}`] ==
        this.appConfig.reservation.defaultUserData.sexMale
      ) {
        /* MEN */
        if (
          this.postForm.value[`2_p_age_${i}`] >=
          this.appConfig.reservation.passengerAgeLimit.adultMin
        ) {
          /* ADULT */
          stats.adultMen++;
        } else {
          /* CHILDREN */
          stats.childrenMen++;
        }
      } else {
        /* WOMEN */
        if (
          this.postForm.value[`2_p_age_${i}`] >=
          this.appConfig.reservation.passengerAgeLimit.adultMin
        ) {
          /* ADULT */
          stats.adultWomen++;
        } else {
          /* CHILDREN */
          stats.childrenWomen++;
        }
      }
    }

    /* CHECK DATA IF THEY ARE VALID */
    if (
      this.cartData[1].passenger.adult.men +
        this.cartData[1].passenger.children.men !=
        stats.adultMen + stats.childrenMen ||
      this.cartData[1].passenger.adult.women +
        this.cartData[1].passenger.children.women !=
        stats.adultWomen + stats.childrenWomen
    ) {
      /* NUMBER OF MALE & FEMALE */
      this.tempData.errorMember.notValid = true;
    } else if (this.cartData[1].passenger.adult.total == 0) {
      /* CHECK CHILDREN ONLY */
      if (stats.adultMen != 0 || stats.adultWomen != 0) {
        this.tempData.errorMember.notValid = true;
      }
    } else if (
      this.cartData[1].passenger.adult.total != 0 &&
      this.cartData[1].passenger.children.total != 0
    ) {
      /* CHECK NUMBER OF ADULTS & CHILDREN TOGETHER */
      if (
        stats.adultMen == this.cartData[1].passenger.adult.men &&
        stats.adultWomen == this.cartData[1].passenger.adult.women &&
        stats.childrenMen == this.cartData[1].passenger.children.men &&
        stats.childrenWomen == this.cartData[1].passenger.children.women
      ) {
        /* DO NOTHING */
      } else {
        this.tempData.errorMember.notValid = true;
      }
    }

    /* RETURN DATA */
    if (this._.isEmpty(this.tempData.errorMember)) {
      this.tempData.errorMember = null;
      return true;
    }
    return false;
  }

  onSubmit() {
    this.tempData.formSubmitted = true;

    /* FORM ZEN TO HAN */
    this.commonService.convertFormInputZenToHan(this.postForm);

    if (this.postForm.invalid) {
      /* SCROLL TO THE FIRST ERROR FORM */
      if (this.$(".form-error-msg:visible").length !== 0) {
        this.$("html, body").animate(
          {
            scrollTop:
              this.$(".form-error-msg:visible").first().offset().top - 90,
          },
          200
        );
      }
      return false;
    }

    /* CHECK VALID MEMBERS */
    if (!this.validateMembers()) {
      return false;
    }

    for (let key in this.postForm.value) {
      if (this.postForm.value[key] != "") {
        if (
          !this.commonService.isNumeric(this.postForm.value[key]) &&
          this.postForm.value[key] &&
          this.postForm.value[key] != ""
        ) {
          this.postData[key] = this.commonService.convertZenToHan(
            this.postForm.value[key]
          );
        } else {
          this.postData[key] = this.postForm.value[key];
        }
      }
    }

    /* RE-SET TEL */
    let telParts = this.commonService.getBBTelParts(this.postData["2_p_tel_1"]);
    this.postData["2_p_tel1_1"] = telParts[0];
    this.postData["2_p_tel2_1"] = telParts[1];
    this.postData["2_p_tel3_1"] = telParts[2];
    /* END */

    let tempUser: any = [];
    for (let i = 0; i < this.listUser.length; i++) {
      tempUser.push({
        sei: this.postData["2_p_sei_" + (i + 1)],
        mei: this.postData["2_p_mei_" + (i + 1)],
        age: parseInt(this.postData["2_p_age_" + (i + 1)]),
      });
    }

    /* Check insurance */
    let insuranceBoth = false;

    if (this.insurancePassengerData1.length === tempUser.length) {
      for (let i = 0; i < this.insurancePassengerData1.length; i++) {
        if (
          JSON.stringify(this.insurancePassengerData1[i]) ===
          JSON.stringify(tempUser[i])
        ) {
          insuranceBoth = true;
        } else {
          insuranceBoth = false;
          break;
        }
      }
    }

    /* SAVE RESERVATION DATA */
    this.postData["representationType_plan2"] = this.representationType;
    const zurichInsuranceHidden = this.reservationService.isNeedHideZurich(
      this.postData["1_dpt_ymd"],
      this.postData["c_birthday"],
      this.cartData
    );
    this.postData.chubbInsuranceHidden = !insuranceBoth;
    this.postData.goToInsurancePage = insuranceBoth || !zurichInsuranceHidden;
    this.reservationService.saveReservationData(this.postData);

    /* GO TO NEXT PAGE */
    /* CHECK IF SEAT MAP IS AVAILABLE */
    if (this.cartData[1].plan.seat_choosable == 1) {
      this.commonService.redirectToRoute(
        this.commonService.routePaths.pageReserveSeatMapPlan2
      );
    } else {
      if (this.postData.goToInsurancePage) {
        this.commonService.redirectToRoute(
          this.commonService.routePaths.pageReserveInsurance
        );
      } else {
        this.commonService.redirectToRoute(
          this.commonService.routePaths.pageReservePayment
        );
      }
    }
  }

  inlineJS() {
    let self = this;
    this.$(document).ready(function () {
      /* INIT INPUT ZEN TO HAN */
      self.commonService.zenToHan();
    });
  }
}
